import React, { useState } from 'react';
import { Mail, RefreshCw, CheckCircle } from 'lucide-react';
import { GlassButton } from '../ui/GlassButton';
import { apiClient } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import './EmailVerificationModal.css';

const EmailVerificationModal: React.FC = () => {
    const { user } = useAuth();
    const [isSending, setIsSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleResend = async () => {
        setIsSending(true);
        setError('');
        setSent(false);
        try {
            await apiClient.post('/auth/resend-verification');
            setSent(true);
        } catch (err: any) {
            setError('Failed to resend. Please try again in a moment.');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="ev-modal-overlay">
            <div className="ev-modal">
                <div className="ev-modal-icon">
                    <Mail size={32} strokeWidth={1.5} />
                </div>

                <h2 className="ev-modal-title">Verify your email address</h2>

                <p className="ev-modal-body">
                    We sent a verification link to <strong>{user?.email}</strong>.
                    Click the link in that email to activate your account.
                </p>

                <p className="ev-modal-hint">
                    Can't find it? Check your spam folder, or click below to send a new link.
                </p>

                {error && (
                    <div className="ev-modal-error">{error}</div>
                )}

                {sent && (
                    <div className="ev-modal-success">
                        <CheckCircle size={16} />
                        Verification email sent — check your inbox.
                    </div>
                )}

                <GlassButton
                    variant="primary"
                    onClick={handleResend}
                    disabled={isSending}
                    loading={isSending}
                    className="ev-modal-btn"
                >
                    <RefreshCw size={15} style={{ marginRight: 6 }} />
                    Resend verification email
                </GlassButton>

                <p className="ev-modal-footer">
                    Wrong email address?{' '}
                    <button
                        className="ev-modal-logout-link"
                        onClick={() => {
                            localStorage.removeItem('access_token');
                            localStorage.removeItem('refresh_token');
                            window.location.href = '/login';
                        }}
                    >
                        Log out
                    </button>
                </p>
            </div>
        </div>
    );
};

export default EmailVerificationModal;
